import { render, staticRenderFns } from "./MenuPagePopup.vue?vue&type=template&id=07b6ab58&scoped=true"
import script from "./MenuPagePopup.vue?vue&type=script&lang=js"
export * from "./MenuPagePopup.vue?vue&type=script&lang=js"
import style0 from "./MenuPagePopup.vue?vue&type=style&index=0&id=07b6ab58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6ab58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b6ab58')) {
      api.createRecord('07b6ab58', component.options)
    } else {
      api.reload('07b6ab58', component.options)
    }
    module.hot.accept("./MenuPagePopup.vue?vue&type=template&id=07b6ab58&scoped=true", function () {
      api.rerender('07b6ab58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/popupWindows/components/MenuPagePopup.vue"
export default component.exports